/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdistatusComment.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edistatus-comment";

export class AutogenModelEdistatusComment<RowType extends ModelRow> extends Endpoint<RowType, RowEdistatusCommentFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdistatusComment extends ModelRow<RowEdistatusCommentFields> {
	constructor(values?: Partial<RowEdistatusCommentFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdistatusCommentFields {
	comment_type: string;
	comments: string;
	company_id: string;
	edistatus_id: string;
	id: string;
	is_callin: string;
	sequence: number;
}

